// extracted by mini-css-extract-plugin
export default {"ylwCircle":"Highlight_ylwCircle__Nwzpz","blinking":"Highlight_blinking__n3fMo","blink":"Highlight_blink__ELq64"};